var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"picture-popup"},[_c('img',{attrs:{"src":_vm.pinInfo.imageSrc}})]),_vm._v(" "),_c('div',{staticClass:"text-popup"},[_c('h4',[_vm._v(_vm._s(_vm.$tdb(_vm.pinInfo.pinTitle)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$tdb(_vm.pinInfo.pinDescription)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }